export const data = { supplemental: { languageMatching: { "written-new": [
	{ paradigmLocales: { _locales: "en en_GB es es_419 pt_BR pt_PT" } },
	{ $enUS: { _value: "AS+CA+GU+MH+MP+PH+PR+UM+US+VI" } },
	{ $cnsar: { _value: "HK+MO" } },
	{ $americas: { _value: "019" } },
	{ $maghreb: { _value: "MA+DZ+TN+LY+MR+EH" } },
	{ no: {
		_desired: "nb",
		_distance: "1"
	} },
	{ bs: {
		_desired: "hr",
		_distance: "4"
	} },
	{ bs: {
		_desired: "sh",
		_distance: "4"
	} },
	{ hr: {
		_desired: "sh",
		_distance: "4"
	} },
	{ sr: {
		_desired: "sh",
		_distance: "4"
	} },
	{ aa: {
		_desired: "ssy",
		_distance: "4"
	} },
	{ de: {
		_desired: "gsw",
		_distance: "4",
		_oneway: "true"
	} },
	{ de: {
		_desired: "lb",
		_distance: "4",
		_oneway: "true"
	} },
	{ no: {
		_desired: "da",
		_distance: "8"
	} },
	{ nb: {
		_desired: "da",
		_distance: "8"
	} },
	{ ru: {
		_desired: "ab",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "ach",
		_distance: "30",
		_oneway: "true"
	} },
	{ nl: {
		_desired: "af",
		_distance: "20",
		_oneway: "true"
	} },
	{ en: {
		_desired: "ak",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "am",
		_distance: "30",
		_oneway: "true"
	} },
	{ es: {
		_desired: "ay",
		_distance: "20",
		_oneway: "true"
	} },
	{ ru: {
		_desired: "az",
		_distance: "30",
		_oneway: "true"
	} },
	{ ur: {
		_desired: "bal",
		_distance: "20",
		_oneway: "true"
	} },
	{ ru: {
		_desired: "be",
		_distance: "20",
		_oneway: "true"
	} },
	{ en: {
		_desired: "bem",
		_distance: "30",
		_oneway: "true"
	} },
	{ hi: {
		_desired: "bh",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "bn",
		_distance: "30",
		_oneway: "true"
	} },
	{ zh: {
		_desired: "bo",
		_distance: "20",
		_oneway: "true"
	} },
	{ fr: {
		_desired: "br",
		_distance: "20",
		_oneway: "true"
	} },
	{ es: {
		_desired: "ca",
		_distance: "20",
		_oneway: "true"
	} },
	{ fil: {
		_desired: "ceb",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "chr",
		_distance: "20",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "ckb",
		_distance: "30",
		_oneway: "true"
	} },
	{ fr: {
		_desired: "co",
		_distance: "20",
		_oneway: "true"
	} },
	{ fr: {
		_desired: "crs",
		_distance: "20",
		_oneway: "true"
	} },
	{ sk: {
		_desired: "cs",
		_distance: "20"
	} },
	{ en: {
		_desired: "cy",
		_distance: "20",
		_oneway: "true"
	} },
	{ en: {
		_desired: "ee",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "eo",
		_distance: "30",
		_oneway: "true"
	} },
	{ es: {
		_desired: "eu",
		_distance: "20",
		_oneway: "true"
	} },
	{ da: {
		_desired: "fo",
		_distance: "20",
		_oneway: "true"
	} },
	{ nl: {
		_desired: "fy",
		_distance: "20",
		_oneway: "true"
	} },
	{ en: {
		_desired: "ga",
		_distance: "20",
		_oneway: "true"
	} },
	{ en: {
		_desired: "gaa",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "gd",
		_distance: "20",
		_oneway: "true"
	} },
	{ es: {
		_desired: "gl",
		_distance: "20",
		_oneway: "true"
	} },
	{ es: {
		_desired: "gn",
		_distance: "20",
		_oneway: "true"
	} },
	{ hi: {
		_desired: "gu",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "ha",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "haw",
		_distance: "20",
		_oneway: "true"
	} },
	{ fr: {
		_desired: "ht",
		_distance: "20",
		_oneway: "true"
	} },
	{ ru: {
		_desired: "hy",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "ia",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "ig",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "is",
		_distance: "20",
		_oneway: "true"
	} },
	{ id: {
		_desired: "jv",
		_distance: "20",
		_oneway: "true"
	} },
	{ en: {
		_desired: "ka",
		_distance: "30",
		_oneway: "true"
	} },
	{ fr: {
		_desired: "kg",
		_distance: "30",
		_oneway: "true"
	} },
	{ ru: {
		_desired: "kk",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "km",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "kn",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "kri",
		_distance: "30",
		_oneway: "true"
	} },
	{ tr: {
		_desired: "ku",
		_distance: "30",
		_oneway: "true"
	} },
	{ ru: {
		_desired: "ky",
		_distance: "30",
		_oneway: "true"
	} },
	{ it: {
		_desired: "la",
		_distance: "20",
		_oneway: "true"
	} },
	{ en: {
		_desired: "lg",
		_distance: "30",
		_oneway: "true"
	} },
	{ fr: {
		_desired: "ln",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "lo",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "loz",
		_distance: "30",
		_oneway: "true"
	} },
	{ fr: {
		_desired: "lua",
		_distance: "30",
		_oneway: "true"
	} },
	{ hi: {
		_desired: "mai",
		_distance: "20",
		_oneway: "true"
	} },
	{ en: {
		_desired: "mfe",
		_distance: "30",
		_oneway: "true"
	} },
	{ fr: {
		_desired: "mg",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "mi",
		_distance: "20",
		_oneway: "true"
	} },
	{ en: {
		_desired: "ml",
		_distance: "30",
		_oneway: "true"
	} },
	{ ru: {
		_desired: "mn",
		_distance: "30",
		_oneway: "true"
	} },
	{ hi: {
		_desired: "mr",
		_distance: "30",
		_oneway: "true"
	} },
	{ id: {
		_desired: "ms",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "mt",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "my",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "ne",
		_distance: "30",
		_oneway: "true"
	} },
	{ nb: {
		_desired: "nn",
		_distance: "20"
	} },
	{ no: {
		_desired: "nn",
		_distance: "20"
	} },
	{ en: {
		_desired: "nso",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "ny",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "nyn",
		_distance: "30",
		_oneway: "true"
	} },
	{ fr: {
		_desired: "oc",
		_distance: "20",
		_oneway: "true"
	} },
	{ en: {
		_desired: "om",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "or",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "pa",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "pcm",
		_distance: "20",
		_oneway: "true"
	} },
	{ en: {
		_desired: "ps",
		_distance: "30",
		_oneway: "true"
	} },
	{ es: {
		_desired: "qu",
		_distance: "30",
		_oneway: "true"
	} },
	{ de: {
		_desired: "rm",
		_distance: "20",
		_oneway: "true"
	} },
	{ en: {
		_desired: "rn",
		_distance: "30",
		_oneway: "true"
	} },
	{ fr: {
		_desired: "rw",
		_distance: "30",
		_oneway: "true"
	} },
	{ hi: {
		_desired: "sa",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "sd",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "si",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "sn",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "so",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "sq",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "st",
		_distance: "30",
		_oneway: "true"
	} },
	{ id: {
		_desired: "su",
		_distance: "20",
		_oneway: "true"
	} },
	{ en: {
		_desired: "sw",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "ta",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "te",
		_distance: "30",
		_oneway: "true"
	} },
	{ ru: {
		_desired: "tg",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "ti",
		_distance: "30",
		_oneway: "true"
	} },
	{ ru: {
		_desired: "tk",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "tlh",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "tn",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "to",
		_distance: "30",
		_oneway: "true"
	} },
	{ ru: {
		_desired: "tt",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "tum",
		_distance: "30",
		_oneway: "true"
	} },
	{ zh: {
		_desired: "ug",
		_distance: "20",
		_oneway: "true"
	} },
	{ ru: {
		_desired: "uk",
		_distance: "20",
		_oneway: "true"
	} },
	{ en: {
		_desired: "ur",
		_distance: "30",
		_oneway: "true"
	} },
	{ ru: {
		_desired: "uz",
		_distance: "30",
		_oneway: "true"
	} },
	{ fr: {
		_desired: "wo",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "xh",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "yi",
		_distance: "30",
		_oneway: "true"
	} },
	{ en: {
		_desired: "yo",
		_distance: "30",
		_oneway: "true"
	} },
	{ zh: {
		_desired: "za",
		_distance: "20",
		_oneway: "true"
	} },
	{ en: {
		_desired: "zu",
		_distance: "30",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "aao",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "abh",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "abv",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "acm",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "acq",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "acw",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "acx",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "acy",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "adf",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "aeb",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "aec",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "afb",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "ajp",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "apc",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "apd",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "arq",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "ars",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "ary",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "arz",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "auz",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "avl",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "ayh",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "ayl",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "ayn",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "ayp",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "bbz",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "pga",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "shu",
		_distance: "10",
		_oneway: "true"
	} },
	{ ar: {
		_desired: "ssh",
		_distance: "10",
		_oneway: "true"
	} },
	{ az: {
		_desired: "azb",
		_distance: "10",
		_oneway: "true"
	} },
	{ et: {
		_desired: "vro",
		_distance: "10",
		_oneway: "true"
	} },
	{ ff: {
		_desired: "ffm",
		_distance: "10",
		_oneway: "true"
	} },
	{ ff: {
		_desired: "fub",
		_distance: "10",
		_oneway: "true"
	} },
	{ ff: {
		_desired: "fue",
		_distance: "10",
		_oneway: "true"
	} },
	{ ff: {
		_desired: "fuf",
		_distance: "10",
		_oneway: "true"
	} },
	{ ff: {
		_desired: "fuh",
		_distance: "10",
		_oneway: "true"
	} },
	{ ff: {
		_desired: "fui",
		_distance: "10",
		_oneway: "true"
	} },
	{ ff: {
		_desired: "fuq",
		_distance: "10",
		_oneway: "true"
	} },
	{ ff: {
		_desired: "fuv",
		_distance: "10",
		_oneway: "true"
	} },
	{ gn: {
		_desired: "gnw",
		_distance: "10",
		_oneway: "true"
	} },
	{ gn: {
		_desired: "gui",
		_distance: "10",
		_oneway: "true"
	} },
	{ gn: {
		_desired: "gun",
		_distance: "10",
		_oneway: "true"
	} },
	{ gn: {
		_desired: "nhd",
		_distance: "10",
		_oneway: "true"
	} },
	{ iu: {
		_desired: "ikt",
		_distance: "10",
		_oneway: "true"
	} },
	{ kln: {
		_desired: "enb",
		_distance: "10",
		_oneway: "true"
	} },
	{ kln: {
		_desired: "eyo",
		_distance: "10",
		_oneway: "true"
	} },
	{ kln: {
		_desired: "niq",
		_distance: "10",
		_oneway: "true"
	} },
	{ kln: {
		_desired: "oki",
		_distance: "10",
		_oneway: "true"
	} },
	{ kln: {
		_desired: "pko",
		_distance: "10",
		_oneway: "true"
	} },
	{ kln: {
		_desired: "sgc",
		_distance: "10",
		_oneway: "true"
	} },
	{ kln: {
		_desired: "tec",
		_distance: "10",
		_oneway: "true"
	} },
	{ kln: {
		_desired: "tuy",
		_distance: "10",
		_oneway: "true"
	} },
	{ kok: {
		_desired: "gom",
		_distance: "10",
		_oneway: "true"
	} },
	{ kpe: {
		_desired: "gkp",
		_distance: "10",
		_oneway: "true"
	} },
	{ luy: {
		_desired: "ida",
		_distance: "10",
		_oneway: "true"
	} },
	{ luy: {
		_desired: "lkb",
		_distance: "10",
		_oneway: "true"
	} },
	{ luy: {
		_desired: "lko",
		_distance: "10",
		_oneway: "true"
	} },
	{ luy: {
		_desired: "lks",
		_distance: "10",
		_oneway: "true"
	} },
	{ luy: {
		_desired: "lri",
		_distance: "10",
		_oneway: "true"
	} },
	{ luy: {
		_desired: "lrm",
		_distance: "10",
		_oneway: "true"
	} },
	{ luy: {
		_desired: "lsm",
		_distance: "10",
		_oneway: "true"
	} },
	{ luy: {
		_desired: "lto",
		_distance: "10",
		_oneway: "true"
	} },
	{ luy: {
		_desired: "lts",
		_distance: "10",
		_oneway: "true"
	} },
	{ luy: {
		_desired: "lwg",
		_distance: "10",
		_oneway: "true"
	} },
	{ luy: {
		_desired: "nle",
		_distance: "10",
		_oneway: "true"
	} },
	{ luy: {
		_desired: "nyd",
		_distance: "10",
		_oneway: "true"
	} },
	{ luy: {
		_desired: "rag",
		_distance: "10",
		_oneway: "true"
	} },
	{ lv: {
		_desired: "ltg",
		_distance: "10",
		_oneway: "true"
	} },
	{ mg: {
		_desired: "bhr",
		_distance: "10",
		_oneway: "true"
	} },
	{ mg: {
		_desired: "bjq",
		_distance: "10",
		_oneway: "true"
	} },
	{ mg: {
		_desired: "bmm",
		_distance: "10",
		_oneway: "true"
	} },
	{ mg: {
		_desired: "bzc",
		_distance: "10",
		_oneway: "true"
	} },
	{ mg: {
		_desired: "msh",
		_distance: "10",
		_oneway: "true"
	} },
	{ mg: {
		_desired: "skg",
		_distance: "10",
		_oneway: "true"
	} },
	{ mg: {
		_desired: "tdx",
		_distance: "10",
		_oneway: "true"
	} },
	{ mg: {
		_desired: "tkg",
		_distance: "10",
		_oneway: "true"
	} },
	{ mg: {
		_desired: "txy",
		_distance: "10",
		_oneway: "true"
	} },
	{ mg: {
		_desired: "xmv",
		_distance: "10",
		_oneway: "true"
	} },
	{ mg: {
		_desired: "xmw",
		_distance: "10",
		_oneway: "true"
	} },
	{ mn: {
		_desired: "mvf",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "bjn",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "btj",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "bve",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "bvu",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "coa",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "dup",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "hji",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "id",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "jak",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "jax",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "kvb",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "kvr",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "kxd",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "lce",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "lcf",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "liw",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "max",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "meo",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "mfa",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "mfb",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "min",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "mqg",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "msi",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "mui",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "orn",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "ors",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "pel",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "pse",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "tmw",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "urk",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "vkk",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "vkt",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "xmm",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "zlm",
		_distance: "10",
		_oneway: "true"
	} },
	{ ms: {
		_desired: "zmi",
		_distance: "10",
		_oneway: "true"
	} },
	{ ne: {
		_desired: "dty",
		_distance: "10",
		_oneway: "true"
	} },
	{ om: {
		_desired: "gax",
		_distance: "10",
		_oneway: "true"
	} },
	{ om: {
		_desired: "hae",
		_distance: "10",
		_oneway: "true"
	} },
	{ om: {
		_desired: "orc",
		_distance: "10",
		_oneway: "true"
	} },
	{ or: {
		_desired: "spv",
		_distance: "10",
		_oneway: "true"
	} },
	{ ps: {
		_desired: "pbt",
		_distance: "10",
		_oneway: "true"
	} },
	{ ps: {
		_desired: "pst",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qub",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qud",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "quf",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qug",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "quh",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "quk",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qul",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qup",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qur",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qus",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "quw",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qux",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "quy",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qva",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qvc",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qve",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qvh",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qvi",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qvj",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qvl",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qvm",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qvn",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qvo",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qvp",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qvs",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qvw",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qvz",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qwa",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qwc",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qwh",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qws",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qxa",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qxc",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qxh",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qxl",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qxn",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qxo",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qxp",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qxr",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qxt",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qxu",
		_distance: "10",
		_oneway: "true"
	} },
	{ qu: {
		_desired: "qxw",
		_distance: "10",
		_oneway: "true"
	} },
	{ sc: {
		_desired: "sdc",
		_distance: "10",
		_oneway: "true"
	} },
	{ sc: {
		_desired: "sdn",
		_distance: "10",
		_oneway: "true"
	} },
	{ sc: {
		_desired: "sro",
		_distance: "10",
		_oneway: "true"
	} },
	{ sq: {
		_desired: "aae",
		_distance: "10",
		_oneway: "true"
	} },
	{ sq: {
		_desired: "aat",
		_distance: "10",
		_oneway: "true"
	} },
	{ sq: {
		_desired: "aln",
		_distance: "10",
		_oneway: "true"
	} },
	{ syr: {
		_desired: "aii",
		_distance: "10",
		_oneway: "true"
	} },
	{ uz: {
		_desired: "uzs",
		_distance: "10",
		_oneway: "true"
	} },
	{ yi: {
		_desired: "yih",
		_distance: "10",
		_oneway: "true"
	} },
	{ zh: {
		_desired: "cdo",
		_distance: "10",
		_oneway: "true"
	} },
	{ zh: {
		_desired: "cjy",
		_distance: "10",
		_oneway: "true"
	} },
	{ zh: {
		_desired: "cpx",
		_distance: "10",
		_oneway: "true"
	} },
	{ zh: {
		_desired: "czh",
		_distance: "10",
		_oneway: "true"
	} },
	{ zh: {
		_desired: "czo",
		_distance: "10",
		_oneway: "true"
	} },
	{ zh: {
		_desired: "gan",
		_distance: "10",
		_oneway: "true"
	} },
	{ zh: {
		_desired: "hak",
		_distance: "10",
		_oneway: "true"
	} },
	{ zh: {
		_desired: "hsn",
		_distance: "10",
		_oneway: "true"
	} },
	{ zh: {
		_desired: "lzh",
		_distance: "10",
		_oneway: "true"
	} },
	{ zh: {
		_desired: "mnp",
		_distance: "10",
		_oneway: "true"
	} },
	{ zh: {
		_desired: "nan",
		_distance: "10",
		_oneway: "true"
	} },
	{ zh: {
		_desired: "wuu",
		_distance: "10",
		_oneway: "true"
	} },
	{ zh: {
		_desired: "yue",
		_distance: "10",
		_oneway: "true"
	} },
	{ "*": {
		_desired: "*",
		_distance: "80"
	} },
	{ "en-Latn": {
		_desired: "am-Ethi",
		_distance: "10",
		_oneway: "true"
	} },
	{ "ru-Cyrl": {
		_desired: "az-Latn",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "bn-Beng",
		_distance: "10",
		_oneway: "true"
	} },
	{ "zh-Hans": {
		_desired: "bo-Tibt",
		_distance: "10",
		_oneway: "true"
	} },
	{ "ru-Cyrl": {
		_desired: "hy-Armn",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "ka-Geor",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "km-Khmr",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "kn-Knda",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "lo-Laoo",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "ml-Mlym",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "my-Mymr",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "ne-Deva",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "or-Orya",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "pa-Guru",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "ps-Arab",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "sd-Arab",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "si-Sinh",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "ta-Taml",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "te-Telu",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "ti-Ethi",
		_distance: "10",
		_oneway: "true"
	} },
	{ "ru-Cyrl": {
		_desired: "tk-Latn",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "ur-Arab",
		_distance: "10",
		_oneway: "true"
	} },
	{ "ru-Cyrl": {
		_desired: "uz-Latn",
		_distance: "10",
		_oneway: "true"
	} },
	{ "en-Latn": {
		_desired: "yi-Hebr",
		_distance: "10",
		_oneway: "true"
	} },
	{ "sr-Cyrl": {
		_desired: "sr-Latn",
		_distance: "5"
	} },
	{ "zh-Hans": {
		_desired: "za-Latn",
		_distance: "10",
		_oneway: "true"
	} },
	{ "zh-Hans": {
		_desired: "zh-Hani",
		_distance: "20",
		_oneway: "true"
	} },
	{ "zh-Hant": {
		_desired: "zh-Hani",
		_distance: "20",
		_oneway: "true"
	} },
	{ "ar-Arab": {
		_desired: "ar-Latn",
		_distance: "20",
		_oneway: "true"
	} },
	{ "bn-Beng": {
		_desired: "bn-Latn",
		_distance: "20",
		_oneway: "true"
	} },
	{ "gu-Gujr": {
		_desired: "gu-Latn",
		_distance: "20",
		_oneway: "true"
	} },
	{ "hi-Deva": {
		_desired: "hi-Latn",
		_distance: "20",
		_oneway: "true"
	} },
	{ "kn-Knda": {
		_desired: "kn-Latn",
		_distance: "20",
		_oneway: "true"
	} },
	{ "ml-Mlym": {
		_desired: "ml-Latn",
		_distance: "20",
		_oneway: "true"
	} },
	{ "mr-Deva": {
		_desired: "mr-Latn",
		_distance: "20",
		_oneway: "true"
	} },
	{ "ta-Taml": {
		_desired: "ta-Latn",
		_distance: "20",
		_oneway: "true"
	} },
	{ "te-Telu": {
		_desired: "te-Latn",
		_distance: "20",
		_oneway: "true"
	} },
	{ "zh-Hans": {
		_desired: "zh-Latn",
		_distance: "20",
		_oneway: "true"
	} },
	{ "ja-Jpan": {
		_desired: "ja-Latn",
		_distance: "5",
		_oneway: "true"
	} },
	{ "ja-Jpan": {
		_desired: "ja-Hani",
		_distance: "5",
		_oneway: "true"
	} },
	{ "ja-Jpan": {
		_desired: "ja-Hira",
		_distance: "5",
		_oneway: "true"
	} },
	{ "ja-Jpan": {
		_desired: "ja-Kana",
		_distance: "5",
		_oneway: "true"
	} },
	{ "ja-Jpan": {
		_desired: "ja-Hrkt",
		_distance: "5",
		_oneway: "true"
	} },
	{ "ja-Hrkt": {
		_desired: "ja-Hira",
		_distance: "5",
		_oneway: "true"
	} },
	{ "ja-Hrkt": {
		_desired: "ja-Kana",
		_distance: "5",
		_oneway: "true"
	} },
	{ "ko-Kore": {
		_desired: "ko-Hani",
		_distance: "5",
		_oneway: "true"
	} },
	{ "ko-Kore": {
		_desired: "ko-Hang",
		_distance: "5",
		_oneway: "true"
	} },
	{ "ko-Kore": {
		_desired: "ko-Jamo",
		_distance: "5",
		_oneway: "true"
	} },
	{ "ko-Hang": {
		_desired: "ko-Jamo",
		_distance: "5",
		_oneway: "true"
	} },
	{ "*-*": {
		_desired: "*-*",
		_distance: "50"
	} },
	{ "ar-*-$maghreb": {
		_desired: "ar-*-$maghreb",
		_distance: "4"
	} },
	{ "ar-*-$!maghreb": {
		_desired: "ar-*-$!maghreb",
		_distance: "4"
	} },
	{ "ar-*-*": {
		_desired: "ar-*-*",
		_distance: "5"
	} },
	{ "en-*-$enUS": {
		_desired: "en-*-$enUS",
		_distance: "4"
	} },
	{ "en-*-GB": {
		_desired: "en-*-$!enUS",
		_distance: "3"
	} },
	{ "en-*-$!enUS": {
		_desired: "en-*-$!enUS",
		_distance: "4"
	} },
	{ "en-*-*": {
		_desired: "en-*-*",
		_distance: "5"
	} },
	{ "es-*-$americas": {
		_desired: "es-*-$americas",
		_distance: "4"
	} },
	{ "es-*-$!americas": {
		_desired: "es-*-$!americas",
		_distance: "4"
	} },
	{ "es-*-*": {
		_desired: "es-*-*",
		_distance: "5"
	} },
	{ "pt-*-$americas": {
		_desired: "pt-*-$americas",
		_distance: "4"
	} },
	{ "pt-*-$!americas": {
		_desired: "pt-*-$!americas",
		_distance: "4"
	} },
	{ "pt-*-*": {
		_desired: "pt-*-*",
		_distance: "5"
	} },
	{ "zh-Hant-$cnsar": {
		_desired: "zh-Hant-$cnsar",
		_distance: "4"
	} },
	{ "zh-Hant-$!cnsar": {
		_desired: "zh-Hant-$!cnsar",
		_distance: "4"
	} },
	{ "zh-Hant-*": {
		_desired: "zh-Hant-*",
		_distance: "5"
	} },
	{ "*-*-*": {
		_desired: "*-*-*",
		_distance: "4"
	} }
] } } };
